__webpack_require__.p = "/offers/_next/";